import React from 'react';
import Card from '../../components/ui/Card.jsx';
import Input from '../../components/ui/Input.jsx';
import Button from '../../components/ui/Button.jsx';
import { apiFetch } from '../../api.js';
import { useApi } from '../../hooks/useApi.js';

export default function StaffCourseList() {
  const { data, loading, error } = useApi('/api/course-list');
  const [form, setForm] = React.useState(null);
  const [saving, setSaving] = React.useState(false);
  const [message, setMessage] = React.useState({ text: '', tone: 'info' });

  React.useEffect(() => {
    if (!data) return;
    setForm({
      cat1: data.cat1 || '',
      cat2: data.cat2 || '',
      cat3: (data.cat3 || []).join(', '),
      cat4: (data.cat4 || []).join(', '),
      courses4000: (data.courses4000 || []).join(', '),
      courses5000: (data.courses5000 || []).join(', ')
    });
  }, [data]);

  const updateField = (key) => (event) => {
    setForm((prev) => ({ ...prev, [key]: event.target.value }));
  };

  const handleReset = () => {
    if (!data) return;
    setForm({
      cat1: data.cat1 || '',
      cat2: data.cat2 || '',
      cat3: (data.cat3 || []).join(', '),
      cat4: (data.cat4 || []).join(', '),
      courses4000: (data.courses4000 || []).join(', '),
      courses5000: (data.courses5000 || []).join(', ')
    });
    setMessage({ text: '', tone: 'info' });
  };

  const handleSave = async () => {
    if (!form) return;
    setSaving(true);
    setMessage({ text: '', tone: 'info' });
    const payload = {
      cat1: form.cat1,
      cat2: form.cat2,
      cat3: splitCSV(form.cat3),
      cat4: splitCSV(form.cat4),
      courses4000: splitCSV(form.courses4000),
      courses5000: splitCSV(form.courses5000)
    };
    try {
      await apiFetch('/api/course-list', {
        method: 'PUT',
        body: JSON.stringify(payload)
      });
      setMessage({ text: 'Course list saved.', tone: 'info' });
    } catch (err) {
      setMessage({ text: err?.message || 'Failed to save course list.', tone: 'error' });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="page">
      <div className="page-header">
        <div>
          <h1>Course List</h1>
          <p className="subtle">Maintain course categories and elective pools.</p>
        </div>
      </div>
      {error ? <div className="alert error">{error}</div> : null}
      {message.text ? <div className={message.tone === 'error' ? 'alert error' : 'alert'}>{message.text}</div> : null}
      {loading || !form ? (
        <p className="subtle">Loading...</p>
      ) : (
        <Card title="Category Courses">
          <div className="form-grid">
            <Input label="Category 1" value={form.cat1} onChange={updateField('cat1')} />
            <Input label="Category 2" value={form.cat2} onChange={updateField('cat2')} />
            <Input label="Category 3" value={form.cat3} onChange={updateField('cat3')} />
            <Input label="Category 4" value={form.cat4} onChange={updateField('cat4')} />
            <Input label="4000-level Electives" value={form.courses4000} onChange={updateField('courses4000')} />
            <Input label="5000-level Electives" value={form.courses5000} onChange={updateField('courses5000')} />
          </div>
          <div className="form-actions">
            <Button variant="secondary" type="button" onClick={handleReset}>Reset</Button>
            <Button type="button" disabled={saving} onClick={handleSave}>{saving ? 'Saving…' : 'Save'}</Button>
          </div>
        </Card>
      )}
    </div>
  );
}

function splitCSV(value) {
  return value
    .split(',')
    .map((part) => part.trim())
    .filter(Boolean);
}
